import { ca } from '@cian/analytics';

/**
 * @description Событие: клик по стрелке навигации карусели Серия Плюс.
 */
export function trackSeriaPlusCarouselArrowClick(direction: 'left' | 'right'): void {
  ca('eventSite', {
    action: 'click_seria_plus_carousel_arrow',
    category: 'Promo',
    label: direction,
    name: 'oldevent',
    useLastProducts: true,
  });
}
